export class CidadeUsuarioDto { }
